import {
  EnumDropdown,
  EnumDropdownCreateForm,
  PureEnumDropdown,
  PureEnumDropdownProps,
} from './EnumDropdown';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants';
import { translate } from '../../helpers';
import { PureEnumMultiDropdownField, PureEnumMultiDropdownFieldProps } from './EnumMultiDropdown';

const fieldName = ISSUE_ATTRIBUTE_NAMES.COST; // 'costImpact'

export const CostImpactFormikField = () => (
  <EnumDropdown
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={fieldName}
    clearable
  />
);

export const CostImpactInCreateForm = () => {
  const fieldName = ISSUE_ATTRIBUTE_NAMES.COST;
  return (
    <EnumDropdownCreateForm
      fieldName={fieldName}
      label={translate(`new.${fieldName}`)}
      placeholder={translate(`new.placeholder.${fieldName}`)}
      id={fieldName}
      clearable
    />
  );
};

export const CostImpactField = ({
  value,
  onChange,
  disabled,
}: Pick<PureEnumDropdownProps, 'value' | 'onChange' | 'disabled'>) => (
  <PureEnumDropdown
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={`inline-${fieldName}`}
    value={value}
    onChange={onChange}
    clearable
    disabled={disabled}
  />
);

export const CostImpactMultiSelectField = ({
  value,
  onChange,
  disabled = false,
  'data-testid': dataTestId,
}: Pick<PureEnumMultiDropdownFieldProps, 'value' | 'onChange' | 'disabled' | 'data-testid'>) => (
  <PureEnumMultiDropdownField
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={`inline-${fieldName}`}
    value={value}
    onChange={onChange}
    disabled={disabled}
    withUnspecified
    clearable
    data-testid={dataTestId}
  />
);
